import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetEntityJsonConfigurationQueryVariables = Types.Exact<{
   params: Types.GetEntityJsonConfigurationParams
}>

export type GetEntityJsonConfigurationQuery = {
   __typename?: 'Query'
   getEntityJsonConfiguration:
      | {
           __typename?: 'EntityJsonConfigurationDoesNotExists'
           message?: string | null
           entityId?: string | null
           entityType: Types.JsonConfigurationEntityType
        }
      | {
           __typename?: 'GetEntityJsonConfigurationResult'
           jsonConfiguration: {
              __typename?: 'JsonConfiguration'
              jsonData: string
           }
        }
      | { __typename?: 'NotSupportedJsonConfigurationEntity' }
      | { __typename?: 'PortalNotFound' }
}

export const GetEntityJsonConfigurationDocument = gql`
   query GetEntityJsonConfiguration(
      $params: GetEntityJsonConfigurationParams!
   ) {
      getEntityJsonConfiguration(params: $params) {
         ... on GetEntityJsonConfigurationResult {
            jsonConfiguration {
               jsonData
            }
         }
         ... on EntityJsonConfigurationDoesNotExists {
            message
            entityId
            entityType
         }
      }
   }
`
export type GetEntityJsonConfigurationQueryResult = Apollo.QueryResult<
   GetEntityJsonConfigurationQuery,
   GetEntityJsonConfigurationQueryVariables
>
